import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import WeChatHousePrefab from "../weChat/WeChatHousePrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class phonePrefab extends cc.Component {

    async onBtnChat(){
        NormalGameManager._instance.mGameLayer.onBtnOpenPrefab(null,"weChat");
    }

    onBtnJiJin(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        getOneBundleOnePrefab(BUNDLE_SMALL_NAME.investStockGameBundle,"prefab/investStockStartPage").then((prefab:cc.Prefab)=>{
            if(prefab){
                let node:cc.Node = cc.instantiate(prefab);
                node.setParent(O1HD.Canvas());
            }
        });
    }

    onBtnLianAiJi(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        getOneBundleOnePrefab(BUNDLE_SMALL_NAME.loveStroyGameBundle,"prefab/loveStoryPrefab").then((prefab:cc.Prefab)=>{
            if(prefab){
                let node:cc.Node = cc.instantiate(prefab);
                node.setParent(O1HD.Canvas());
            }
        });
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal", "phone");
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
        this.node.removeFromParent();
    }

}
